import { createAsyncThunk } from '@reduxjs/toolkit'
import { factory } from '../../../utils/apiThunkFactory';
export const countAllUsersByTenant = factory.get('statistics/getLivekitUrl', '/api/admin/countUsers');
export const countConnectedUsersByTenant = factory.get('statistics/countConnectedUsersByTenant', '/api/admin/connected');
export const countConnectedGuestByTenant = factory.get('statistics/countConnectedGuestByTenant', '/api/admin/connectedGuests');
export const filterUser = factory.post('statistics/filterUser', '/api/admin/users');
export const AddUser = factory.post('statistics/AddUser', '/api/admin/adduser');
export const UpdateUser = factory.put('statistics/UpdateUser', '/api/admin/updateUser/:email');
export const DeleteUser = factory.delete('statistics/DeleteUser', '/api/admin/users/:email');
export const tenantsMap = factory.get('statistics/all-tenants-maps', '/api/tenants/all-tenants-maps');
export const CountAllUsersByTenantByMap = factory.get('statistics/countAllUsersByTenantByMap', '/api/stats/online/:mapId/:tenantId');
export const StatConnectedUsers = factory.post('statistics/StatConnectedUsers', '/api/stats/connectedUsers');
export const StatConnectedGuest = factory.post('statistics/StatConnectedGuest', '/api/stats/connectedGuests');
export const StatInvitationSent = factory.post('statistics/invitation', '/api/stats/invitation');
export const StatMessages = factory.post('statistics/message', '/api/stats/message');
export const ActiveAccounts = factory.post('statistics/ActiveAccounts', '/api/stats/activeAccounts');
export const getTenantMonthlyReportForUser = factory.get('statistics/getTenantMonthlyReport', '/api/stats/monthlyReport');

///////////////////report 
export const getTenantMonthlyReport = factory.get('statistics/getTenantMonthlyReport', '/api/monthly_report/monthlyReport/:tenantId');


export const StatAllConnectedByTenantByMap = createAsyncThunk(
    "statistics/StatAllConnectedByTenantByMap",
    async ({ period, map_id, tenantId }, { dispatch, rejectWithValue }) => {
        try {
            // Lancer les deux requêtes en parallèle
            const [usersRes, guestsRes] = await Promise.all([
                dispatch(StatConnectedUsers({ body: { period, map_id, tenantId } })).unwrap(),
                dispatch(StatConnectedGuest({ body: { period, map_id, tenantId } })).unwrap()
            ]);

            // Fusionner les deux tableaux par label
            const allLabels = new Set([
                ...usersRes.points.map(p => p.label),
                ...guestsRes.points.map(p => p.label)
            ]);

            const mergedPoints = Array.from(allLabels).map(label => {
                const userPoint = usersRes.points.find(p => p.label === label);
                const guestPoint = guestsRes.points.find(p => p.label === label);

                return {
                    label,
                    countUser: userPoint ? userPoint.count : 0,
                    countGuest: guestPoint ? guestPoint.count : 0
                };
            });

            return mergedPoints;

        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);


export const StatAllCommunicationByTenantByMap = createAsyncThunk(
    "statistics/StatAllCommunicationByTenantByMap",
    async ({ period, map_id, tenantId }, { dispatch, rejectWithValue }) => {
        try {
            // Lancer les deux requêtes en parallèle
            const [invitationRes, messageRes] = await Promise.all([
                dispatch(StatInvitationSent({ body: { period, map_id, tenantId } })).unwrap(),
                dispatch(StatMessages({ body: { period, map_id, tenantId } })).unwrap()
            ]);

            // Fusionner les deux tableaux par label
            const allLabels = new Set([
                ...invitationRes.points.map(p => p.label),
                ...messageRes.points.map(p => p.label)
            ]);

            const mergedPoints = Array.from(allLabels).map(label => {
                const invitationPoint = invitationRes.points.find(p => p.label === label);
                const messagePoint = messageRes.points.find(p => p.label === label);

                return {
                    label,
                    countInvitation: invitationPoint ? invitationPoint.count : 0,
                    countMessage: messagePoint ? messagePoint.count : 0
                };
            });

            return mergedPoints;

        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);